import { render } from "./Dialer.vue?vue&type=template&id=5fbf90a8&scoped=true&lang=pug"
import script from "./Dialer.vue?vue&type=script&lang=js"
export * from "./Dialer.vue?vue&type=script&lang=js"

import "./Dialer.vue?vue&type=style&index=0&id=5fbf90a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fbf90a8"

export default script